import { Box, Divider, Typography } from '@mui/material';
import { Card } from 'src/components/UI/Card';
import { LOCATION_ICON, PHONE_ICON, PERSON_ICON } from './NotesIcons';
import {
  notesContainerSx,
  notesTitleSx,
  notesListContainerSx,
  notesItemContainerSx,
  notesItemTextSx,
  notesDividerSx
} from '../styles/createCampaign';

interface NoteItem {
  icon: string;
  note: string;
}

const NOTES: NoteItem[] = [
  {
    icon: PERSON_ICON,
    note: 'Requires follow-up by client after submission.'
  },
  {
    icon: PHONE_ICON,
    note: 'Requires phone verification by client after submission.'
  },
  {
    icon: LOCATION_ICON,
    note: 'This Citation allows you to hide the address. Perfect for Service-area businesses.'
  }
];

export const Notes = () => {
  return (
    <Card>
      <Box sx={notesContainerSx}>
        <Typography sx={notesTitleSx}>Notes</Typography>

        <Box sx={notesListContainerSx}>
          {NOTES.map((note, index) => (
            <Box key={`note-${index}`}>
              <Box sx={notesItemContainerSx}>
                <img src={note.icon} alt={note.note} width={18} height={18} />
                <Typography sx={notesItemTextSx}>{note.note}</Typography>
              </Box>
              {index !== NOTES.length - 1 && <Divider sx={notesDividerSx} />}
            </Box>
          ))}
        </Box>
      </Box>
    </Card>
  );
};
